import{decorateProperty as t}from"@lit/reactive-element/decorators/base.js";import{ContextProvider as e}from"../controllers/context-provider.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function o({context:o}){return t({finisher:(t,n)=>{const r=new WeakMap;t.addInitializer((t=>{r.set(t,new e(t,{context:o}))}));const i=Object.getOwnPropertyDescriptor(t.prototype,n),c=null==i?void 0:i.set,s={...i,set:function(t){var e;null===(e=r.get(this))||void 0===e||e.setValue(t),c&&c.call(this,t)}};Object.defineProperty(t.prototype,n,s)}})}export{o as provide};
//# sourceMappingURL=provide.js.map
